import React from 'react';

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  const renderPagination = () => {
    const isTooManyPages = totalPages > 5;
    const startPage = Math.max(currentPage - 1, 1);
    const endPage = Math.min(currentPage + 1, totalPages);

    return (
      <div
        className="pagination"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '5px',
        }}
      >
        {/* Previous Button */}
        <button
         type="button"
          onClick={() => handlePageChange(currentPage - 1)}
          style={{
            border: '1px solid #ddd',
            padding: '0 8px',
            cursor: currentPage > 1 ? 'pointer' : 'not-allowed',
            borderRadius: '4px',
            opacity: currentPage > 1 ? '1' : '0.5',
            backgroundColor: '#f0f0f0',
            color: 'black',
          }}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {/* Always show the first page */}
        <button
        type="button"
          onClick={() => handlePageChange(1)}
          style={{
            border: '1px solid #ddd',
            padding: '0 8px',
            cursor: 'pointer',
            borderRadius: '4px',
            backgroundColor: currentPage === 1 ? 'var(--mainCol)' : '#f0f0f0',
            color: currentPage === 1 ? 'white' : 'black',
          }}
        >
          1
        </button>

        {/* Show ellipsis if current page is far from the start */}
        {isTooManyPages && currentPage > 3 && (
          <span style={{ padding: '0 5px' }}>...</span>
        )}

        {/* Show middle pages */}
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => {
          if (page > 1 && page < totalPages) {
            return (
              <button
              type="button"
                key={page}
                onClick={() => handlePageChange(page)}
                style={{
                  border: '1px solid #ddd',
                  padding: '0 8px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  backgroundColor: currentPage === page ? 'var(--mainCol)' : '#f0f0f0',
                  color: currentPage === page ? 'white' : 'black',
                }}
              >
                {page}
              </button>
            );
          }
          return null;
        })}

        {/* Show ellipsis if current page is far from the end */}
        {isTooManyPages && currentPage < totalPages - 2 && (
          <span style={{ padding: '0 5px' }}>...</span>
        )}

        {/* Always show the last page */}
        {totalPages > 1 && (
          <button
          type="button"
            onClick={() => handlePageChange(totalPages)}
            style={{
              border: '1px solid #ddd',
              padding: '0 8px',
              cursor: 'pointer',
              borderRadius: '4px',
              backgroundColor: currentPage === totalPages ? 'var(--mainCol)' : '#f0f0f0',
              color: currentPage === totalPages ? 'white' : 'black',
            }}
          >
            {totalPages}
          </button>
        )}

        {/* Next Button */}
        <button
        type="button"
          onClick={() => handlePageChange(currentPage + 1)}
          style={{
            border: '1px solid #ddd',
            padding: '0 8px',
            cursor: currentPage < totalPages ? 'pointer' : 'not-allowed',
            borderRadius: '4px',
            opacity: currentPage < totalPages ? '1' : '0.5',
            backgroundColor: '#f0f0f0',
            color: 'black',
          }}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return renderPagination();
};

export default Pagination;